import React from 'react'

import { ThemeProvider } from '@mui/material'
import { getTheme } from 'themes'

import Button from 'components_new/atoms/Button'

import SelectSearch, { Option } from 'components_new/molecules/SelectSearch'
import SimpleDialog from 'components_new/molecules/SimpleDialog'
import { useTranslation } from 'language/translator'

interface SettingsSelectDialogProps {
  onChange: (params: Option[]) => void
  onClose: () => void
  onSubmit: () => void
  open: boolean
  options: Option[]
  title: string
  value: Option[]
  variant?: 'add' | 'edit'
}

export type TInputOption = { disabled?: boolean; label: string; value: any }

const SettingsSelectDialog = (props: SettingsSelectDialogProps) => {
  const { onChange, onClose, onSubmit, options, open, title, value, variant } =
    props

  const { t } = useTranslation()

  const handleSubmit = () => {
    onSubmit()
    onClose()
  }

  return (
    <ThemeProvider theme={getTheme('light')}>
      <SimpleDialog
        actions={
          <>
            <Button onClick={onClose} variant="text">
              {t('global', 'cancel')}
            </Button>
            <Button onClick={handleSubmit} disabled={value.length === 0}>
              {variant === 'add' ? t('global', 'add') : t('global', 'save')}
            </Button>
          </>
        }
        disableRestoreFocus={true}
        open={open}
        onClose={onClose}
        sx={{
          zIndex: 1302 // for fullSize
        }}
        title={`${
          variant === 'add' ? t('global', 'add') : t('global', 'edit')
        } ${title.toLowerCase()}`}
      >
        <SelectSearch
          onChange={(options: Option[]) => onChange(options)}
          multiple={true}
          options={options}
          selected={value}
          sort={true}
        />
      </SimpleDialog>
    </ThemeProvider>
  )
}

export default SettingsSelectDialog
